module.exports = __webpack_public_path__ + "img/list.64217274.svg";